<template>
<sub-page>
  <h1>Feedback</h1>
</sub-page>
</template>

<script>
export default {
  name: "adminCrmBusinesses"
}
</script>

<style scoped>

</style>